import React, {useState} from 'react'
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
} from '@radix-ui/react-dropdown-menu'
import { FiChevronDown, FiChevronUp } from 'react-icons/fi'
import { Button } from '../../styles/_app.style'
import { Item } from '../../styles/navigation.style'
import { Content } from '../navigation/navDropdowns/navDropdown.style'

interface UniversityDropdownProps {
  value: string
  onChange: (val: string) => void
  options: string[]
  open?: boolean
  onOpenChange?: (open: boolean) => void
  triggerDataAttr?: string
}

const UniversityDropdown: React.FC<UniversityDropdownProps> = ({
  value,
  onChange,
  options,
  triggerDataAttr = 'university',
}) => {



    const [open, setOpen] = useState(false)

  return (
    <DropdownMenu open={open} onOpenChange={setOpen}>
      <DropdownMenuTrigger asChild data-dropdown={triggerDataAttr}>
        <Button
          icon
          css={{
            minWidth: '9rem',
            padding: '0 1rem',
            justifyContent: 'space-between',
            gap: '0.25rem',
            fontSize: '$sm',
          }}
          aria-label="Select university"
          title="Select university"
        >
          {value}
          {open ? <FiChevronUp /> : <FiChevronDown />}
        </Button>
      </DropdownMenuTrigger>

      <DropdownMenuContent
        data-dropdown={triggerDataAttr}
        align="start"
        sideOffset={4}
        style={{
            maxHeight: '15rem',        // limit height for scrolling
            overflowY: 'auto',         // enable vertical scroll
            zIndex: 999,
            fontSize: '$sm',
        }}
        asChild
      >
        <Content style={{ minWidth: '8rem' }}>
          {options.map(opt => (
            <Item
              key={opt}
              onSelect={() => onChange(opt)}
              style={{ width: '100%' }}
              title={opt}
            >
              {opt}
            </Item>
          ))}
        </Content>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}

export default UniversityDropdown